import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {HomePage} from './home';
import {IonicStepperModule} from "ionic-stepper";

@NgModule({
  declarations: [HomePage],
  imports: [IonicPageModule.forChild(HomePage), IonicStepperModule]
})
export class HomePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts